import React from "react";
import "./InterviewConfidenceLevel.css";
import { useNavigate, useParams } from "react-router-dom";

const InterviewConfidenceLevel = () => {
    const navigate = useNavigate();
    const { id } = useParams();
  
  return (
    <div className="confidence-container">
      <h1>Confidence Level (How Sure Are You About Your Answer?)</h1>

      <section className="confidence-section">
        <h2>What is Confidence Level?</h2>
        <p>
          Confidence level reflects how sure you are about your answer, whether
          it's right or wrong. It's about how confident you feel in your response.
        </p>
      </section>

      <section className="confidence-section">
        <h2>Why is it Important?</h2>
        <p>
          Understanding your confidence helps track whether you're guessing,
          unsure, or truly certain about your answer. It also helps identify areas
          where you might need more practice.
        </p>
      </section>

      <section className="confidence-section">
        <h2>How is it Measured?</h2>
        <p>
          The system tracks patterns in how you answer questions, such as:
          <ul>
            <li>Do you quickly choose an answer without hesitation? (High confidence)</li>
            <li>Do you second-guess or take time to answer? (Low confidence)</li>
          </ul>
        </p>
      </section>

      <section className="confidence-section">
        <h2>Real-life Example:</h2>
        <p>
          Imagine you're answering a quiz. If you're sure about your answer and
          quickly submit it, the system might rate your confidence as high, even
          if the answer is wrong. If you're unsure and take longer to answer, the
          system would rate your confidence lower.
        </p>
      </section>

      <section className="confidence-section">
        <h2>What it Tells Us:</h2>
        <p>
          A high confidence level could mean you're self-assured, but it doesn't
          necessarily mean your answer is correct. A low confidence level could
          mean you're uncertain, and might need extra help on certain topics.
        </p>
      </section>

      <section className="confidence-section">
      <button className="certificate-btn" onClick={() =>  navigate(`/enrolledCourse/ai-interview/${id}/result`)}>Go Back</button>
      </section>
    </div>
  );
};

export default InterviewConfidenceLevel;
